import {createApp} from 'vue'
import ChangesSaved from './ChangesSaved'

const el = '.kb-component--changes-saved'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ChangesSavedDOM)=>{
            const component = createApp(ChangesSaved).use(Store)
            component.mount(ChangesSavedDOM)
        })
    }
}